// Thin wrapper over the unified TrackingStatusBadge for variation status.
// Mirrors SowStatusPill — exists so callers can render
// `<VariationStatusPill status={...}/>` without re-stating
// `kind="variation"` at every call site. Visual behaviour lives in
// TrackingStatusBadge: proposed=amber, approved=emerald, rejected=red
// per brand SKILL.md §9.2.

import TrackingStatusBadge from "../shared/TrackingStatusBadge";
import type { VariationStatus } from "../../../../types";

interface VariationStatusPillProps {
  status: VariationStatus;
}

export default function VariationStatusPill({
  status,
}: VariationStatusPillProps) {
  return <TrackingStatusBadge kind="variation" status={status} />;
}
